import { Link } from "react-router-dom";
const Footer = () => {
    return (
        <footer className="footer-area">
        <div className="container pt-100 pb-70">
             <div className="row">
                <div className="col-lg-3 col-sm-6">
                    <div className="footer-widget">
                        <div className="footer-logo">
                            <Link to="/">
                                <img src="/assets/images/lms-logo.png" alt="Images" />
                            </Link>
                        </div>
                        <p>
                            Lorem ipsum dolor sit amet, consec tetur
                            adipiscing elit eiusmod tempor incididunt
                            labore dolore magna aliqua consec tetur
                            adipiscing elite sed do labor.
                        </p>
                        <ul className="social-link">
                            <li className="social-title">Follow Us:</li>
                            <li>
                                <Link to="https://www.facebook.com/" target="_blank">
                                    <i className="ri-facebook-fill"></i>
                                </Link>
                            </li>
                            <li>
                                <Link to="https://twitter.com/" target="_blank">
                                    <i className="ri-twitter-fill"></i>
                                </Link>
                            </li>
                            <li>
                                <Link to="https://www.pinterest.com/" target="_blank">
                                    <i className="ri-instagram-line"></i>
                                </Link>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="col-lg-3 col-sm-6">
                    <div className="footer-widget ps-5">
                        <h3>About us</h3>
                        <ul className="footer-list">
                            <li>
                                <Link to="/about-us">
                                    About Us
                                </Link>
                            </li> 
                            <li>
                                <Link to="/signup">
                                    Instructor registration
                                </Link>
                            </li> 
                            <li>
                                <a href="instructors.html">
                                    Instructors
                                </a>
                            </li> 
                            <li>
                                <a href="event.html">
                                    Our Event
                                </a>
                            </li> 
                            <li>
                                <a href="courses-list.html">
                                    Courses List
                                </a>
                            </li> 
                        </ul>
                    </div>
                </div>
                <div className="col-lg-3 col-sm-6">
                    <div className="footer-widget ps-5">
                        <h3>Resources</h3>
                        <ul className="footer-list">
                            <li>
                                <Link href="/">
                                    Home
                                </Link>
                            </li> 
                            <li>
                                <a href="courses.html" >
                                    Courses
                                </a>
                            </li> 
                            <li>
                                <a href="blog.html">
                                    Our Blog
                                </a>
                            </li> 
                            <li>
                                <Link to="/terms-conditions">
                                    Terms & conditions
                                </Link>
                            </li> 
                            <li>
                                <Link to="/privacy-policy">
                                    Privacy Policy
                                </Link>
                            </li> 
                        </ul>
                    </div>
                </div>
                <div className="col-lg-3 col-sm-6">
                    <div className="footer-widget ps-5">
                        <h3>Official Info</h3>
                        <ul className="footer-contact">
                            <li>
                                <i className="ri-map-pin-2-fill"></i>
                                <div className="content">
                                    <h4>Location:</h4>
                                    <span>D-103A, Shivam Enclave Achheja, Gautam Buddha Nagar 203207, Uttar Pradesh, India</span>
                                </div>
                            </li>
                            <li>
                                <i className="ri-mail-fill"></i>
                                <div className="content">
                                    <h4>Email:</h4>
                                    <span><Link to="mailto:enquiry@lmsbee.com">enquiry@lmsbee.com</Link></span>
                                </div>
                            </li>
                            <li>
                                <i className="ri-phone-fill"></i>
                                <div className="content">
                                    <h4>Phone:</h4>
                                    <span><Link to="tel:+917307787435">07307787435</Link></span>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div className="copyright-area">
            <div className="container">
                <div className="copy-right-text text-center">
                    <p>
                        Copyright <b>LMSBee</b> All Rights Reserved  
                        <Link to="https://www.brightinfovision.com/" className="ps-2" target="_blank"> BrightInfoVision Technologies</Link> 
                    </p>
                </div>
            </div>
        </div>
    </footer>
   
    );
  }
  
  export default Footer;
  